import _extends from "@babel/runtime-corejs2/helpers/extends";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
var _excluded = ["onSelectListItem", "options", "modifiedSelectedOption"];
import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { Icon } from '@mch-group/uikit-components';
import CMultiSelect from './common/CMultiSelect';

var MultiSelectDropdownWithCheckbox = function MultiSelectDropdownWithCheckbox(_ref) {
  var onSelectListItem = _ref.onSelectListItem,
      options = _ref.options,
      modifiedSelectedOption = _ref.modifiedSelectedOption,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement(CMultiSelect, _extends({
    options: options || [],
    placeholder: "Select",
    displayValue: "text",
    closeOnSelect: true,
    showArrow: true,
    showCheckbox: true // eslint-disable-next-line no-unused-vars
    ,
    onSelect: function onSelect(selectedList, selectedItem) {
      onSelectListItem(null, {
        checked: true
      }, selectedItem);
    } // eslint-disable-next-line no-unused-vars
    ,
    onRemove: function onRemove(selectedList, removedItem) {
      onSelectListItem(null, {
        checked: false
      }, removedItem);
    },
    selectedValues: modifiedSelectedOption,
    customArrow: /*#__PURE__*/React.createElement(Icon, {
      name: "caret-down",
      color: "#000",
      size: 30,
      style: {
        marginBottom: 20,
        paddingStart: 10
      }
    })
  }, rest));
};

MultiSelectDropdownWithCheckbox.propTypes = {
  onSelectListItem: PropTypes.func,
  options: PropTypes.array,
  modifiedSelectedOption: PropTypes.array
};
var MultiSelectDropdownWithCheckboxStyled = styled(MultiSelectDropdownWithCheckbox).withConfig({
  displayName: "MultiSelectDropdownWithCheckbox__MultiSelectDropdownWithCheckboxStyled",
  componentId: "sc-10h6sq8-0"
})([".menu.transition.visible{width:100%;}.ui.checkbox{display:block;padding:10px;:hover{background:rgba(0,0,0,0.05);color:rgba(0,0,0,0.95);}}"]);
export default MultiSelectDropdownWithCheckboxStyled;